import type {
	LinksFunction,
	MetaFunction,
	LoaderFunctionArgs,
} from '@remix-run/node';

import { NavLink, Outlet, useLoaderData } from '@remix-run/react';
import { getUser } from '~/utils/session.server.ts';

import stylesUrl from '~/styles/account/account.css?url';

export const links: LinksFunction = () => {
	return [{ rel: 'stylesheet', href: stylesUrl }];
};

export const meta: MetaFunction = () => [
	{
		title: 'GLists | Your account users',
	},
];

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const user = await getUser(request);
	if (!user) {
		return {
			user: null,
		};
	}
	return {
		user,
	};
};

export default function AccountRoute() {
	const { user } = useLoaderData<typeof loader>();
	return (
		<main id="main" className="account-main main-section">
			{user ? (
				<div className="account-container">
					<section className="account-content">
						<Outlet />
					</section>
					<aside className="account-menu">
						<h2>Account Menu</h2>
						<ul className="account-nav">
							<li className="account-nav--listitem">
								<NavLink
									to=""
									className="account-nav--link"
									end
								>
									Account Home
								</NavLink>
							</li>
							<li className="account-nav--listitem">
								<NavLink
									to="edit"
									className="account-nav--link"
								>
									Edit your account
								</NavLink>
							</li>
							<li className="account-nav--listitem">
								<NavLink
									to="users"
									className="account-nav--link"
								>
									Edit your users
								</NavLink>
							</li>
							{user.email === 'ahallicks@outlook.com' ? (
								<>
									<li className="account-nav--listitem">
										<NavLink
											to="all-users"
											className="account-nav--link"
										>
											View/Edit all users
										</NavLink>
									</li>
									<li className="account-nav--listitem">
										<NavLink
											to="run-migrations"
											className="account-nav--link"
										>
											Run migrations
										</NavLink>
									</li>
								</>
							) : null}
							{user.stripeToken ? (
								<li className="account-nav--listitem">
									<NavLink
										to="portal"
										className="account-nav--link"
									>
										Payment Portal
									</NavLink>
								</li>
							) : null}
							<li className="account-nav--listitem">
								<NavLink
									to="reset-password"
									className="account-nav--link"
								>
									Reset your password
								</NavLink>
							</li>
						</ul>
					</aside>
				</div>
			) : (
				<div className="container account-single">
					<Outlet />
				</div>
			)}
		</main>
	);
}
